import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { FiBarChart2, FiCheckCircle, FiClipboard, FiTrendingUp } from 'react-icons/fi';
import '../Styles/MainStyles/Overview.css';

const Overview = () => {
  return (
    <section id="overview" className="py-5 bg-white">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">System Overview</h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }}>
            Our audit management platform provides end-to-end solutions for organizations of all sizes
          </p>
        </div>
        
        <Row className="g-4 justify-content-center">
          <Col xl={6} lg={6} md={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column">
                <div className="mb-4">
                  <div className="icon-container bg-primary-light text-primary me-3">
                    <FiClipboard size={24} />
                  </div>
                  <h3 className="mb-0 fs-4">Audit Management</h3>
                </div>
                <ul className="list-unstyled mb-0 flex-grow-1">
                  {auditFeatures.map((feature, index) => (
                    <li key={index} className="mb-3 d-flex align-items-start">
                      <FiCheckCircle className="text-success me-2 mt-1 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
          
          <Col xl={6} lg={6} md={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column">
                <div className="mb-4">
                  <div className="icon-container bg-info-light text-info me-3">
                    <FiBarChart2 size={24} />
                  </div>
                  <h3 className="mb-0 fs-4">Reporting & Analytics</h3>
                </div>
                <ul className="list-unstyled mb-0 flex-grow-1">
                  {reportingFeatures.map((feature, index) => (
                    <li key={index} className="mb-3 d-flex align-items-start">
                      <FiCheckCircle className="text-success me-2 mt-1 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Additional benefits section */}
        <div className="text-center mt-5 mb-4">
          <h3 className="fw-bold text-primary">Key Benefits</h3>
        </div>
        
        <Row className="g-4 justify-content-center">
          <Col xl={3} lg={6} md={6} sm={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="icon-container bg-primary-light text-primary mb-3">
                    <FiTrendingUp size={24} />
                  </div>
                  <h4 className="fs-5 mb-3">Improved Efficiency</h4>
                </div>
                <p className="text-muted small mb-0">Streamline audit processes and reduce manual work by up to 70%</p>
              </Card.Body>
            </Card>
          </Col>
          
          <Col xl={3} lg={6} md={6} sm={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="icon-container bg-info-light text-info mb-3">
                    <FiCheckCircle size={24} />
                  </div>
                  <h4 className="fs-5 mb-3">Enhanced Compliance</h4>
                </div>
                <p className="text-muted small mb-0">Meet regulatory requirements with built-in controls and documentation</p>
              </Card.Body>
            </Card>
          </Col>
          
          <Col xl={3} lg={6} md={6} sm={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="icon-container bg-primary-light text-primary mb-3">
                    <FiBarChart2 size={24} />
                  </div>
                  <h4 className="fs-5 mb-3">Data-Driven Insights</h4>
                </div>
                <p className="text-muted small mb-0">Turn audit data into actionable business intelligence</p>
              </Card.Body>
            </Card>
          </Col>
          
          <Col xl={3} lg={6} md={6} sm={12} className="d-flex">
            <Card className="border-0 shadow-sm w-100 overview-card h-100">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="icon-container bg-info-light text-info mb-3">
                    <FiClipboard size={24} />
                  </div>
                  <h4 className="fs-5 mb-3">Centralized Management</h4>
                </div>
                <p className="text-muted small mb-0">Access all audit information from a single, secure platform</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const auditFeatures = [
  'Customizable audit templates for various compliance standards',
  'Real-time collaboration with audit teams',
  'Document management with version control',
  'Automated task assignment and tracking',
  'Workflow automation with approval processes',
  'Risk assessment and control evaluation'
];

const reportingFeatures = [
  'Interactive dashboards with key metrics',
  'Custom report generation with drag-and-drop builder',
  'Advanced data visualization tools',
  'Export capabilities in multiple formats (PDF, Excel, CSV)',
  'Trend analysis and historical comparisons',
  'Automated report distribution'
];

export default Overview;